export default {
  en: {
    /* ----- Common UI Elements ----- */
    pageNotFoundTitle: "Sorry! The link is broken or the page has been moved.",
    pageNotFoundMessage:
      "You may have typed the application address incorrectly or may have used an outdated link from external references. Please go to application homepage and navigate to the desired function. If problem persists, please contact our support team by email.",
    goToHomePage: "Go to Home Page",

    // Common error messages
    technicalDifficulties:
      "There seems to be some technical difficulties while fetching data.",
    accessDeniedMessage: "You don't have access to perform this action.",
    refresh: "Refresh",

    // TopBarActionComponent
    search: "Search",
    apply: "Apply",
    reset: "Reset",

    // Camera component
    takePhoto: "Take Photo",
    pleaseSmile: "PLEASE SMILE",
    openYourMouth: "OPEN YOUR MOUTH",

    // Activity Tracker
    privacy: "Privacy",
    back: "Back",
    change: "Change",
    date: "Date:",
    workSchedule: "Work Schedule:",
    timezone: "Timezone:",
    myDefaultView: "My Default View",
    selectManager: "Select Manager",
    manager: "Manager:",
    noDataAvailable: "No data available",
    retry: "Retry",
    cancel: "Cancel",
    ok: "OK",
    send: "Send",
    shareDashboard: "Share Dashboard",
    to: "To",
    body: "Body",

    // Email Template component
    sendRemainder: "Send remainder",
    resetDefaultMessage: "Reset default message",
    subject: "Subject",
    content: "Content",
    template: "Template",
    emailReminder: "Email Reminder",
    downloadDesktopClient: "Download",
    changesCountMessage: "You have changed {count} setting(s)",
    save: "Save",

    /* ----- Form Field Names ----- */
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    emailAddress: "Email Address",
    value: "Value",
    allocationDate: "Allocation date",
    dataVisibility: "Data visibility",
    insuranceName: "Insurance Name",
    policyNumber: "Policy Number",
    insurerName: "Insurer Name",
    insuredName: "Insured Name",
    sumInsured: "Sum Insured",
    expiryDate: "Expiry Date",
    vendorCompanyName: "Vendor Company Name",
    vendorCompanyEmail: "Vendor Company Email",
    location: "Location",
    urlValidity: "URL Validity",
    durationInDaysHoursMinutes: "Duration in Days/Hours/Minutes",
    ratingDescription: "Rating Description",
    currency: "Currency",
    valueOfOneShare: "Value of 1 share",
    vestingShares: "Vesting shares",
    vestingDate: "Vesting date",
    accountNumber: "Account Number",
    addressLine1: "Address line 1",
    bankName: "Bank Name",
    branchLocation: "Branch Location",
    bsb: "BSB",
    businessName: "Business name",
    checkIn: "Check in",
    checkOut: "Check out",
    city: "City",
    configurationName: "Configuration name",
    country: "Country",
    customEmployeeGroup: "Custom Employee Group",
    description: "Description",
    documentCategory: "Document Category",
    documentName: "Document name",
    employeeName: "Employee Name",
    holidayName: "Holiday Name",
    ifsc: "IFSC",
    numberOfShareUnits: "Number of share units",
    operand: "Operand",
    pinCode: "PinCode",
    postalStreet: "Postal Street",
    state: "State",
    street: "Street",
    taxRegistrationNumber: "Tax registration number",
    templateName: "Template name",
    form: "Form",
    vatGstSalesTaxId: "VAT/GST/Sales Tax ID",
    vendorType: "Vendor Type",
    viewWorkScheduleOvertimeThresholdHours: "Work schedule Code",

    // Employee roles
    admin: "Admin",
    managerRole: "Manager",
    teamMember: "Team Member",

    // LinkedIn Share
    shareAndGetAdditional: "Share and get additional",
    days: "Days",
    likedUsingActivityTracker:
      "We hope you liked using Activity Tracker! Would you mind sharing with your LinekedIn network to extend your trial?",
    shareNow: "Share Now",

    // Desktop Client Download
    activityTracker: "Activity Tracker",
    appVersion: "App Version",
    download: "Download",
    byClickingDownload: "By clicking the Download, you accept the",
    termsAndConditions: "Terms & Conditions",
    copyAgentDownloadLink: "Copy the agent download link",
    copy: "Copy",
    linkCopied: "Link copied!",
    or: "(OR)",
    queryOr: "OR",
    queryAnd: "AND",
    queryAddRule: "Add Rule",
    downloadNotAvailable:
      "Desktop client download is not available. Please contact the platform administrator",

    // Form Close Confirmation
    areYouSureToExitForm: "Are you sure to exit this form?",

    //footer
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",

    // Right Side Sticky Bar
    offer: "Offer",
    help: "Help",
    bookADemo: "Book a Demo",
    watchProductDemo: "Watch Product Demo",
    watchProductVideo: "Watch Product Video",
    howActivityIsMeasured: "How activity is measured?",
    howToInstallUpgrade: "How to install/upgrade my {0}?",
    howToOnboardMyTeam: "How to onboard my team?",
    claimNow: "Claim Now",
    doYouKnowHowActivityIsMeasured: "Do you know how activity is measured?",
    activityLevelsCalculatedDescription:
      "Activity levels are calculated based on the percentage of keyboard and mouse strokes over the total time tracked for a specific period. The activity levels feature lets you know exactly how productive you or your team are when tracking time. You may use this data to address team efficiency on the spot quickly.",
    belowIsHowProductivityIsMeasured: "Below is how productivity is measured:",
    productivityMeasurementTip1:
      "For every second, we label the user as active or inactive. A mouse movement or keyboard stroke = active. No keyboard or mouse = inactive.",
    productivityMeasurementTip2:
      "We add all of these numbers up and give a total % of activity for that 10-minute segment using this equation: Active seconds / 600 = activity rate %",
    clickHereToLearnMore: "Click here to Learn More",
    decideEarlyGetBestOffer: "Decide early and get the best offer",
    subscribeBeforeTrialEnd:
      "Subscribe before the end of the trial period to claim a discount of up to 40%",
    congratulations: "Congratulations!",
    couponCodeReceiveDescription:
      "You will receive the coupon code to apply the discount on the list price. Use it within 2 hours to avail of the offer.",
    somethingWentWrongRequestingCoupon:
      "Something went wrong while requesting the coupon code. If you continue to see this issue, please contact the platform administrator.",

    // Employee Monitoring Intro Screens
    specialOfferForYou: "A special offer for you",
    subscribeToday:
      "Subscribe today to get 6 months free. Yes we are serious, {0}% waived from your annual subscription",
    couponCode: "Coupon Code",
    applyCouponDuringCheckout: "* Apply the coupon code during checkout",
    getOneOnOneHelp: "Get 1-on-1 help",
    bookFreeDemo:
      "Book a free demo today and get personalized support as you set up {0} for your crew",
    bookADemoButton: "Book a demo",
    watchProductDemoButton: "Watch product demo",
    notSureStartTrial: "Not sure? Start your trial and pick later.",
    couponCopied: "Coupon Copied!",
    technicalDifficultiesSubscription:
      "It's us! There seems to be some technical difficulties while creating the default subscription. Please try after some time.",
    noAccessRightsSubscription:
      "Sorry, you don't have access rights to create default subscription. Please contact your administrator.",
    somethingWrongSubscription:
      "Something went wrong while creating the default subscription. Please try after some time.",
    unableToCreateSubscription: "Unable to create default subscription.",
    somethingWrongSubscriptionContact:
      "Something went wrong while creating the default subscription. If you continue to see this problem please talk to your platform administrator.",
    noRightsToActivate:
      "Sorry you don't have rights to activate your account in productivity monitoring. Please contact system administrator.",
    technicalIssueOurSide:
      "Sorry, This issue seems to be from our side. Would you mind trying it after some time or talk to your administrator ?",
    employeeStatusInactive:
      "Employee status is inactive in Core HR hence you are not allowed to activate.",
    somethingWrongActivating:
      "Something went wrong while activating your account in productivity monitoring. Please try after some time.",

    // MoreDetailsCard component
    moreDetails: "More Details",
    by: "by",
    employeeId: "E-ID:",

    // AppWarningModel Component
    defaultDeleteConfirmation: "Are you sure to delete the selected record(s)?",
    commentRequired: "Comment field is required",
    commentLengthError:
      "Comment length should greater than or equal to five characters.",
    commentValidationError:
      "Only alphanumeric, spaces and symbols(+ , / . # & : () ' - ) are allowed.",
    defaultCloseButton: "No",
    defaultAcceptButton: "Yes",

    // TrialNotification Component
    pleaseAddCardDetailsToRenew:
      "Please add the card details to renew the subscription before it expires.",
    subscribeNow: "Subscribe Now",
    freeTrialExpiredAddCard:
      "Your free trial has expired. Please add the card details to renew your subscription.",
    paymentFailedValidateCard:
      "Payment is failed. Please validate your card details for payment to succeed and avoid suspension of account and removal of user data.",
    freeTrialWillExpireWithinDays:
      "Your free trial will expire within {days} day(s).",
    freeTrialWillExpireSoon: "Your free trial will expire soon.",
    noAccessToAddCardDetails:
      "Sorry, you don't have access to add the card details. Please contact your administrator.",
    somethingWentWrongProcessingRequest:
      "Something went wrong while processing your request. If you continue to see this problem please talk to your platform administrator.",
    subscriptionNotCompleted: "Subscription hasn't been completed",
    somethingWentWrongTryLater:
      "Something went wrong. Please try after some time.",

    // UI Elements
    imagePreview: "Image Preview",
    fileExtension: "File Extension",
    newNotificationsMessage: "You have new notifications",
  },
  sp: {
    /* ----- Common UI Elements ----- */
    pageNotFoundTitle:
      "¡Lo sentimos! El enlace está roto o la página ha sido movida.",
    pageNotFoundMessage:
      "Es posible que haya escrito incorrectamente la dirección de la aplicación o que haya utilizado un enlace obsoleto de referencias externas. Por favor, vaya a la página de inicio de la aplicación y navegue hasta la función deseada. Si el problema persiste, póngase en contacto con nuestro equipo de soporte por correo electrónico.",
    goToHomePage: "Ir a la página de inicio",

    // Common error messages
    technicalDifficulties:
      "Parece que hay algunas dificultades técnicas al obtener datos.",
    accessDeniedMessage: "No tienes acceso para realizar esta acción.",
    refresh: "Actualizar",

    // TopBarActionComponent
    search: "Buscar",
    apply: "Aplicar",
    reset: "Restablecer",

    // Camera component
    takePhoto: "Tomar foto",
    pleaseSmile: "POR FAVOR SONRÍA",
    openYourMouth: "ABRA SU BOCA",

    // Activity Tracker
    privacy: "Privacidad",
    back: "Volver",
    change: "Cambiar",
    date: "Fecha:",
    workSchedule: "Horario de Trabajo:",
    timezone: "Zona Horaria:",
    myDefaultView: "Mi Vista Predeterminada",
    selectManager: "Seleccionar Gerente",
    manager: "Gerente:",
    noDataAvailable: "No hay datos disponibles",
    retry: "Reintentar",
    cancel: "Cancelar",
    ok: "Aceptar",
    send: "Enviar",
    shareDashboard: "Compartir Panel",
    to: "Para",
    body: "Cuerpo",

    // Email Template component
    sendRemainder: "Enviar recordatorio",
    resetDefaultMessage: "Restablecer mensaje predeterminado",
    subject: "Asunto",
    content: "Contenido",
    template: "Plantilla",
    emailReminder: "Recordatorio por Correo",
    downloadDesktopClient: "Descargar",
    changesCountMessage: "Ha cambiado {count} configuración(es)",
    save: "Guardar",

    /* ----- Form Field Names ----- */
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    emailAddress: "Dirección de correo electrónico",
    value: "Valor",
    allocationDate: "Fecha de asignación",
    dataVisibility: "Visibilidad de datos",
    insuranceName: "Nombre del seguro",
    policyNumber: "Número de póliza",
    insurerName: "Nombre del asegurador",
    insuredName: "Nombre del asegurado",
    sumInsured: "Suma asegurada",
    expiryDate: "Fecha de vencimiento",
    vendorCompanyName: "Nombre de la empresa proveedora",
    vendorCompanyEmail: "Correo electrónico de la empresa proveedora",
    location: "Ubicación",
    urlValidity: "Validez de URL",
    durationInDaysHoursMinutes: "Duración en días/horas/minutos",
    ratingDescription: "Descripción de calificación",
    currency: "Moneda",
    valueOfOneShare: "Valor de 1 acción",
    vestingShares: "Acciones de consolidación",
    vestingDate: "Fecha de consolidación",
    accountNumber: "Número de cuenta",
    addressLine1: "Línea de dirección 1",
    bankName: "Nombre del banco",
    branchLocation: "Ubicación de la sucursal",
    bsb: "BSB",
    businessName: "Nombre del negocio",
    checkIn: "Entrada",
    checkOut: "Salida",
    city: "Ciudad",
    configurationName: "Nombre de configuración",
    country: "País",
    customEmployeeGroup: "Grupo de empleados personalizado",
    description: "Descripción",
    documentCategory: "Categoría del documento",
    documentName: "Nombre del documento",
    employeeName: "Nombre del empleado",
    holidayName: "Nombre del feriado",
    ifsc: "IFSC",
    numberOfShareUnits: "Número de unidades de acciones",
    operand: "Operando",
    pinCode: "Código postal",
    postalStreet: "Calle postal",
    state: "Estado",
    street: "Calle",
    taxRegistrationNumber: "Número de registro fiscal",
    templateName: "Nombre de plantilla",
    form: "Formulario",
    vatGstSalesTaxId: "ID de IVA/GST/Impuesto de ventas",
    vendorType: "Tipo de proveedor",
    viewWorkScheduleOvertimeThresholdHours: "Código de horario de trabajo",

    // Employee roles
    admin: "Administrador",
    managerRole: "Gerente",
    teamMember: "Miembro del equipo",

    // LinkedIn Share
    shareAndGetAdditional: "Comparta y obtenga adicional",
    days: "Días",
    likedUsingActivityTracker:
      "¡Esperamos que le haya gustado usar Activity Tracker! ¿Le importaría compartirlo con su red de LinkedIn para extender su prueba?",
    shareNow: "Compartir ahora",

    // Desktop Client Download
    activityTracker: "Rastreador de Actividad",
    appVersion: "Versión de la aplicación",
    download: "Descargar",
    byClickingDownload: "Al hacer clic en Descargar, acepta los",
    termsAndConditions: "Términos y Condiciones",
    copyAgentDownloadLink: "Copie el enlace de descarga del agente",
    copy: "Copiar",
    linkCopied: "¡Enlace copiado!",
    or: "(O)",
    queryOr: "O",
    queryAnd: "Y",
    queryAddRule: "Agregar Regla",
    downloadNotAvailable:
      "La descarga del cliente de escritorio no está disponible. Póngase en contacto con el administrador de la plataforma",

    // Form Close Confirmation
    areYouSureToExitForm: "¿Está seguro de salir de este formulario?",
    yes: "Sí",
    no: "No",

    //footer
    termsOfUse: "Condiciones de uso",
    privacyPolicy: "política de privacidad",

    // Right Side Sticky Bar
    offer: "Oferta",
    help: "Ayuda",
    bookADemo: "Reservar una Demostración",
    watchProductDemo: "Ver Demostración del Producto",
    watchProductVideo: "Ver Video del Producto",
    howActivityIsMeasured: "¿Cómo se mide la actividad?",
    howToInstallUpgrade: "¿Cómo instalar/actualizar mi {0}?",
    howToOnboardMyTeam: "¿Cómo incorporar a mi equipo?",
    claimNow: "Reclamar Ahora",
    doYouKnowHowActivityIsMeasured: "¿Sabes cómo se mide la actividad?",
    activityLevelsCalculatedDescription:
      "Los niveles de actividad se calculan en base al porcentaje de pulsaciones de teclado y movimientos del ratón sobre el tiempo total registrado para un período específico. La función de niveles de actividad te permite saber exactamente cuán productivo eres tú o tu equipo al registrar el tiempo. Puedes usar estos datos para abordar la eficiencia del equipo en el momento rápidamente.",
    belowIsHowProductivityIsMeasured:
      "A continuación se muestra cómo se mide la productividad:",
    productivityMeasurementTip1:
      "Para cada segundo, etiquetamos al usuario como activo o inactivo. Un movimiento del ratón o pulsación de teclado = activo. Sin teclado o ratón = inactivo.",
    productivityMeasurementTip2:
      "Sumamos todos estos números y damos un porcentaje total de actividad para ese segmento de 10 minutos usando esta ecuación: Segundos activos / 600 = tasa de actividad %",
    clickHereToLearnMore: "Haga clic aquí para Aprender Más",
    decideEarlyGetBestOffer: "Decida temprano y obtenga la mejor oferta",
    subscribeBeforeTrialEnd:
      "Suscríbase antes del final del período de prueba para reclamar un descuento de hasta el 40%",
    congratulations: "¡Felicitaciones!",
    couponCodeReceiveDescription:
      "Recibirá el código de cupón para aplicar el descuento en el precio de lista. Úselo dentro de 2 horas para aprovechar la oferta.",
    somethingWentWrongRequestingCoupon:
      "Algo salió mal al solicitar el código de cupón. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",

    // Employee Monitoring Intro Screens
    specialOfferForYou: "Una oferta especial para ti",
    subscribeToday:
      "Suscríbete hoy para obtener 6 meses gratis. Sí, hablamos en serio, {0}% de descuento en tu suscripción anual",
    couponCode: "Código de Cupón",
    applyCouponDuringCheckout: "* Aplica el código de cupón durante el pago",
    getOneOnOneHelp: "Obtén ayuda personalizada",
    bookFreeDemo:
      "Reserva una demo gratuita hoy y obtén soporte personalizado mientras configuras {0} para tu equipo",
    bookADemoButton: "Reservar una demo",
    watchProductDemoButton: "Ver demo del producto",
    notSureStartTrial:
      "¿No estás seguro? Comienza tu prueba y elige más tarde.",
    couponCopied: "¡Cupón Copiado!",
    technicalDifficultiesSubscription:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al crear la suscripción predeterminada. Por favor, inténtalo después de un tiempo.",
    noAccessRightsSubscription:
      "Lo sentimos, no tienes derechos de acceso para crear una suscripción predeterminada. Por favor, contacta a tu administrador.",
    somethingWrongSubscription:
      "Algo salió mal al crear la suscripción predeterminada. Por favor, inténtalo después de un tiempo.",
    unableToCreateSubscription:
      "No se puede crear la suscripción predeterminada.",
    somethingWrongSubscriptionContact:
      "Algo salió mal al crear la suscripción predeterminada. Si continúas viendo este problema, habla con el administrador de tu plataforma.",
    noRightsToActivate:
      "Lo sentimos, no tienes derechos para activar tu cuenta en el monitoreo de productividad. Por favor, contacta al administrador del sistema.",
    technicalIssueOurSide:
      "Lo sentimos, este problema parece ser de nuestra parte. ¿Te importaría intentarlo después de un tiempo o hablar con tu administrador?",
    employeeStatusInactive:
      "El estado del empleado está inactivo en Core HR, por lo tanto, no se te permite activar.",
    somethingWrongActivating:
      "Algo salió mal al activar tu cuenta en el monitoreo de productividad. Por favor, inténtalo después de un tiempo.",

    // MoreDetailsCard component
    moreDetails: "Más Detalles",
    by: "por",
    employeeId: "ID-E:",

    // AppWarningModel Component
    defaultDeleteConfirmation:
      "¿Está seguro de eliminar el/los registro(s) seleccionado(s)?",
    commentRequired: "El campo de comentario es obligatorio",
    commentLengthError:
      "La longitud del comentario debe ser mayor o igual a cinco caracteres.",
    commentValidationError:
      "Solo se permiten alfanuméricos, espacios y símbolos(+ , / . # & : () ' - ).",
    defaultCloseButton: "No",
    defaultAcceptButton: "Sí",

    // TrialNotification Component
    pleaseAddCardDetailsToRenew:
      "Por favor, agregue los detalles de la tarjeta para renovar la suscripción antes de que expire.",
    subscribeNow: "Suscribirse Ahora",
    freeTrialExpiredAddCard:
      "Su prueba gratuita ha expirado. Por favor, agregue los detalles de la tarjeta para renovar su suscripción.",
    paymentFailedValidateCard:
      "El pago falló. Por favor, valide los detalles de su tarjeta para que el pago sea exitoso y evite la suspensión de la cuenta y la eliminación de datos del usuario.",
    freeTrialWillExpireWithinDays:
      "Su prueba gratuita expirará dentro de {days} día(s).",
    freeTrialWillExpireSoon: "Su prueba gratuita expirará pronto.",
    noAccessToAddCardDetails:
      "Lo sentimos, no tiene acceso para agregar los detalles de la tarjeta. Por favor, contacte a su administrador.",
    somethingWentWrongProcessingRequest:
      "Algo salió mal al procesar su solicitud. Si continúa viendo este problema, hable con el administrador de su plataforma.",
    subscriptionNotCompleted: "La suscripción no se ha completado",
    somethingWentWrongTryLater:
      "Algo salió mal. Por favor, inténtelo después de un tiempo.",

    // UI Elements
    imagePreview: "Vista Previa de Imagen",
    fileExtension: "Extensión de Archivo",
    newNotificationsMessage: "Tienes nuevas notificaciones",
  },
};
